import React, {Component} from 'react';
import {Row, Col } from "reactstrap";
import {inject, observer} from "mobx-react/index";
import CardDetalhe from "../../../comum/components/CardDetalhe"

@inject("store")
@observer
export default class DetalhesBooking extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        // const qtdCampos = this.props.campos.length;
        return(

            <Col xs={6} className="container-card-detalhe">
                <div>
                    <h4>{this.props.titulo}</h4>                    
                    { this.props.row.map( (row, x) => (
                    <Row className="m-0 mb-2 card-detalhe booking justify-content-between" key={x}>
                        { 
                            this.props.campos.map((el, x) => {
                                return (<Col key={x} sm={'auto'}>
                                    <CardDetalhe icone={el.icone} 
                                                 titulo={el.titulo}
                                                 label={el.label}
                                                 desc={el.field.map((field) => row[field])}
                                                 formatacao={el.formatacao}
                                                 operacaoBooking={this.props.operacaoBooking}
                                                 booking = {this.props.booking}
                                                 entradaCntr={row.Id ? row.Id :""}
                                    />
                            </Col>)

                        })
                        }
                    </Row>)
                    )}
                </div>
            </Col>)
    }
}


// WEBPACK FOOTER //
// ./src/modules/consultas/booking/components/DetalhesBooking.js